import { queryOptions } from '@tanstack/react-query';

import { IConferenceHubCounter } from '@/resources/upgrade/ConferenceHubCounter';
import { apiClient, ICollectionResponse } from '@/resources/upgrade/jsonapi-client';

export function conferenceHubCountersQueryOptions(conferenceIds: Array<string>, hubId: string | undefined) {
  return queryOptions({
    queryKey: ['conference-hub-counters', conferenceIds, hubId],
    queryFn: async () => {
      const response = await apiClient.get<ICollectionResponse<IConferenceHubCounter>>('conference_hub_counters', {
        'filter[conference_id]': conferenceIds.join(','),
        'filter[hub_id]': hubId!,
        'page[number]': '1',
        'page[size]': '100',
      });

      return response.data;
    },
    enabled: conferenceIds.length > 0 && Boolean(hubId),
    staleTime: 1000 * 60 * 5,
  });
}
